import Api from '@/data';
import Constants from '@/utils/constants';

class ApiService {
	static getBusinessSuperCategoryList = () =>
		Api.apiWebClient.get(
			`${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/categoryTree/superCategories`,
		);

	// Same API call is used for category and sub category list
	static getBusinessCategoryList = (categoryNodeId) =>
		Api.apiWebClient.get(
			`${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/categoryTree/node/${categoryNodeId}`,
		);

	static getPincodeDetails = (pincode) =>
		Api.apiWebClient.get(
			`${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/pincode/${pincode}/details`,
		);

	static updateMerchantDetails = (data) =>
		Api.apiWebClient.patch(
			`${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/merchant/profile`,
			{ data },
		);

	static kycInit = (data) =>
		Api.apiWebClient.post(
			`${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/kyc/init`,
			{ data },
		);

	static getKycStatus = (data) =>
		Api.apiWebClient.post(
			`${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/om/journey`,
			{ data },
		);

	static emailVerification = (data) =>
		Api.apiWebClient.post(
			`${Constants.SUB_URL_INSIGHTS}/v1/user/sendVerificationLink`,
			{ data },
		);

	static sendOtp = (data) => {
		const { captcha } = data;
		delete data.captcha;
		return Api.apiWebClient.post(
			`${Constants.SUB_URL_INSIGHTS}/v3/auth/web/sendOtp`,
			{
				data: {
					type: 'OTP',
					phoneNumber: data.phone,
					email: data.email,
					deviceFingerprint: '123',
					...data.metadata,
				},
				headers: {
					[Constants.HCAPTCHA_HEADER_KEY]: captcha,
				},
			},
		);
	};

	static submitOtp = (data) =>
		Api.apiWebClient.post(`${Constants.SUB_URL_INSIGHTS}/v3/auth/web/login`, {
			data: {
				type: 'OTP',
				deviceFingerprint: '123',
				...data,
			},
		});

	static initServiceLine = ({ merchantId, solutionType }) =>
		Api.apiWebClient.post(
			`${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/serviceline/init`,
			{
				data: {
					merchantId,
					serviceLineType: solutionType,
				},
			},
		);

	static getServiceLinesList = (merchantId) =>
		Api.apiWebClient.get(
			`${Constants.SUB_URL_MERCHANT_ONBOARDING}/v1/serviceline/merchants/${merchantId}/details`,
		);
}
export default ApiService;
